<template>
  <div>
    <v-container>
      <v-expansion-panels multiple v-model="panel">
        <v-expansion-panel>
          <v-expansion-panel-header>Date Range</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
                <custom-datepicker
                  :class-padding="classPadding"
                  label="Date From"
                  v-model="dateFrom"
                ></custom-datepicker>
              </v-col>
              <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
                <custom-datepicker :class-padding="classPadding" label="Date To" v-model="dateTo"></custom-datepicker>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Payroll Location</v-expansion-panel-header>
          <v-expansion-panel-content>
            <pay-loc-selection
              :show-dense="false"
              :headers="payLocHeaders"
              :show-select="true"
              v-model="payLoc"
              :by-user="true"
            ></pay-loc-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Department</v-expansion-panel-header>
          <v-expansion-panel-content>
            <department-selection :show-dense="false" :show-select="true" v-model="department"></department-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Division</v-expansion-panel-header>
          <v-expansion-panel-content>
            <division-selection :show-dense="false" :show-select="true" v-model="division"></division-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Branch</v-expansion-panel-header>
          <v-expansion-panel-content>
            <branch-selection :show-dense="false" :show-select="true" v-model="branch"></branch-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Section</v-expansion-panel-header>
          <v-expansion-panel-content>
            <section-selection :show-dense="false" :show-select="true" v-model="section"></section-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Report Option</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-radio-group row v-model="group2" :class="classPadding">
              <v-radio label="Management" value="management"></v-radio>
              <v-radio label="Direct" value="direct"></v-radio>
              <v-radio label="Indirect" value="indirect"></v-radio>
            </v-radio-group>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Status</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-radio-group row v-model="group" :class="classPadding">
              <v-radio label="All" value="2"></v-radio>
              <v-radio label="Active" value="1"></v-radio>
              <v-radio label="Inactive" value="0"></v-radio>
            </v-radio-group>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-row>
        <v-col xs="12" sm="12" md="12">
          <v-btn outlined @click.stop="exportReport" :loading="loading" :class="classPadding">Export</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import moment from "moment";
const CustomDatepicker = () => import("../../../components/CustomDatepicker");
const PayLocSelection = () =>
  import("../../setup/general/payroll-location/NewSelection");
const DepartmentSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/department/NewSelection"
  );

const DivisionSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/division/NewSelection"
  );
const BranchSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/branch/NewSelection"
  );

const SectionSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/section/NewSelection"
  );
const API_ENDPOINT = "/api/reports";
export default {
  data: () => ({
    title: "Purge Employee Masterfile",
    classPadding: "my-0 py-0",
    dateFrom: null,
    dateTo: null,
    payLocHeaders: [
      {
        text: "Loc Id",
        align: "left",
        //sortable: false,
        value: "locId"
      },
      {
        text: "Location Name",
        align: "left",
        //sortable: false,
        value: "locName"
      }
    ],
    payLoc: [],
    department: [],
    division: [],
    branch: [],
    section: [],
    isSearching: false,
    employees: [],
    loading: false,
    group: "2",
    panel: [7],
    effectDate: null,
    group2: "management"
  }),
  components: {
    CustomDatepicker,
    PayLocSelection,
    DepartmentSelection,
    DivisionSelection,
    BranchSelection,
    SectionSelection
  },
  computed: {
    grp() {
      return this.payLoc.join(", ");
    },
    dep() {
      return this.department.join(", ");
    },
    div() {
      return this.division.join(", ");
    },
    bra() {
      return this.branch.join(", ");
    },
    sec() {
      return this.section.join(", ");
    }
  },
  methods: {
    reset() {
      this.dateFrom = null;
      this.dateTo = null;
      this.payLoc = [];
      this.department = [];
      this.division = [];
      this.branch = [];
      this.section = [];
    },
    exportReport() {
      this.loading = true;
      var data = {
        Grp: this.grp,
        Dep: this.dep,
        Bra: this.bra,
        Div: this.div,
        Sec: this.sec,
        Stat: this.group,
        DateFrom: moment(this.dateFrom).format("MM/DD/YYYY"),
        DateTo: moment(this.dateTo).format("MM/DD/YYYY"),
        Group2: this.group2
      };
      this.$axios
        .post(`${API_ENDPOINT}/manpower-management`, data)
        .then(({ data }) => {
          var subPath = process.env.VUE_APP_PATH;

          window.open(
            `${subPath.slice(0, -1)}/report-viewer?reportCode=${
              data.reportCode
            }&dbName=${data.dbName}&key=${data.key}&companyKey=${
              data.companyKey
            }&reportUrl=${data.url}&client=${data.client}&logoAlign=${
              data.logoAlign
            }&logoWidth=${data.logoWidth}&rpt=${data.rpt}`
          );
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted() {}
};
</script>
